// 为组件提供 install 方法，供组件对外按需引入
import Component from './src/index.vue'
import { info, defaultProps, editer, events, dataSource } from './src/config'
Component.install = (Vue) => {
  Vue.component(Component.name, Component)
}
Component.info = info
Component.defaultProps = defaultProps
Component.editer = editer
Component.events = events
Component.dataSource = dataSource
export default Component
